import {
  webRoute,mobileRoute,
  otherProjectsRoute,
  productDesignsRoute,
} from "../constants/routeConstants";
import { cadDesign, mobile, productDesign, web } from "../data/categories";
import { Category } from "../models/projectModel";

export function generateRoute(category: Category) {
  
  var path =
    category.name === mobile.name
      ? mobileRoute
      : category.name === web.name
      ? webRoute
      : category.name === productDesign.name
      ? productDesignsRoute
      : category.name === cadDesign.name
      ? productDesignsRoute
      : otherProjectsRoute;

      // console.log(path)
  return path;
}
